<template>
  <div>
    <div v-if="topServices === 'true'" class="row custom-card-group">
      <div v-for="index in 10" :key="index" class="col card custom-card-loader loader">
        <div class="card-body custom-card-body"></div>
      </div>
    </div>
    <div v-if="topServicesEmpty === 'true'" class="row custom-card-group">
      <div v-for="index in 10" :key="index" class="col card custom-card-loader loader">
        <div class="card-body custom-card-body">
          <EmptyData />
        </div>
      </div>
    </div>
    <div v-if="topcards" class="loader" style="height: 513px"></div>
    <div v-if="charts === 'true'" class="loader py-3 px-md-2 px-1" style="height: 513px"></div>
    <div v-if="card" class="row m-0 dashboard-shop-card">
      <div v-for="index in 4" :key="index" class="col-12 col-sm-6 col-md-3 shop-list-container p-2">
        <div class="shop-list-div p-3 loader" style="height: 130px"></div>
      </div>
    </div>
    <div v-if="emptyCard" class="row m-0 dashboard-shop-card">
      <div v-for="index in 4" :key="index" class="col-12 col-sm-6 col-md-3 shop-list-container p-2">
        <div class="shop-list-div p-3 loader" style="height: 130px">
          <EmptyData />
        </div>
      </div>
    </div>
    <div v-if="singleCard" class="shop-list-div p-3 loader" style="height: 170px"></div>
    <div v-if="singleEmptyCard" class="shop-list-div p-3 loader" style="height: 170px">
      <EmptyData />
    </div>
    <div v-if="vehicleSummary" class="custom-vehicle-details-host loader" style="height: 200px; text-align: center"></div>
    <div v-if="vehicleSummaryEmpty" class="custom-vehicle-details-host loader" style="height: 200px; text-align: center">
      <EmptyData />
    </div>
    <div v-if="documents" class="custom-file-list-none loader" style="height: 120px">
      <span style="top: 40px; position: relative"></span>
    </div>
    <div v-if="emptyDocuments">
      <span>{{ nothingFound }}</span>
    </div>
  </div>
</template>
<script>
import EmptyData from '@/components/utilities/elements/emptyData.vue'
export default {
  name: 'RepairNetwork',
  components: {
    EmptyData
  },
  props: {
    topServices: String,
    topServicesEmpty: String,
    topcards: String,
    charts: String,
    card: String,
    emptyCard: String,
    singleCard: String,
    singleEmptyCard: String,
    vehicleSummary: String,
    documents: String,
    emptyDocuments: String,
    vehicleSummaryEmpty: String,
    nothingFound: String
  }
}
</script>
<style scoped></style>
